import * as React from 'react';
import { DropzoneFile } from '../../index';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import CloseIcon from 'material-ui-icons/Close';
import IconButton from 'material-ui/IconButton';
import { withStyles } from 'material-ui/styles';
import { StyleProps } from '../../../../utils/style';
import { CSSProperties } from 'react';
import Paper from 'material-ui/Paper';
import * as R from 'ramda';
import { MediaItem } from '../../../../store/Entities/Media/media.reducer';
import { CircularProgress } from 'material-ui/Progress';
import CheckIcon from 'material-ui-icons/Check';
import SaveIcon from 'material-ui-icons/Save';
import ErrorIcon from 'material-ui-icons/Error';
import green from 'material-ui/colors/green';
import red from 'material-ui/colors/red';
import { getCdnUrl } from '../../../../utils/cdn';

const styleSheet = {
  container: {
    height: '100%',
  } as CSSProperties,
  select: {
    border: 'dashed 1px rgba(255, 255, 255, 0.12)',
    minHeight: 140,
  },
  selectFileButton: {
    color: '#ffff8c',
  } as CSSProperties,
  paper: {
    position: 'relative',
  },
  closeIcon: {
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 10000,
    color: 'black',
  },
  successButton: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  errorButton: {
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  progress: {
    color: green[500],
    position: 'absolute',
    top: -2,
    left: -2,
  },
};

interface OwnProps {
  isDragActive: boolean;
  isDragReject: boolean;
  acceptedFiles?: DropzoneFile[];
  rejectedFiles?: DropzoneFile[];
  onReset?: () => void;
  mediaItem?: MediaItem;
  uploadFailed: boolean;
  onUploaded?: (mediaItem: MediaItem) => any;
  width?: number;
  height?: number;
  acceptedTypes: string[];
}

type Props = StyleProps & OwnProps;

class UploadArea extends React.PureComponent<Props> {
  private previews = [];

  public componentDidUpdate(prevProps: Props) {
    const { mediaItem, onUploaded } = this.props;
    if (mediaItem && onUploaded && mediaItem !== prevProps.mediaItem) {
      onUploaded(mediaItem);
    }
  }

  private handleResetClick = (event: React.SyntheticEvent<any>) => {
    const { onReset } = this.props;
    if (onReset) {
      onReset();
    }
    event.preventDefault();
    event.stopPropagation();
  };

  private renderMedia() {
    const { classes, mediaItem, acceptedFiles, width, height } = this.props;
    if (!acceptedFiles) {
      return null;
    }
    const acceptedFile = R.head(acceptedFiles);
    if (!acceptedFile) {
      return null;
    }
    R.append(acceptedFile.preview, this.previews);
    const previewUrl =
      mediaItem && mediaItem.hash
        ? getCdnUrl(mediaItem.hash)
        : acceptedFile.preview;

    return (
      <Grid
        spacing={0}
        container={true}
        style={{ height: height || '100%', width: width || '100%' }}
      >
        <Grid item={true}>
          <Paper className={classes.paper}>
            <img
              style={{ maxHeight: height || '100%', maxWidth: width || '100%' }}
              src={previewUrl}
            />
            <IconButton
              onClick={this.handleResetClick}
              className={classes.closeIcon}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
            {this.renderLoading()}
          </Paper>
        </Grid>
      </Grid>
    );
  }

  private renderSelect() {
    const { classes, width, height, acceptedTypes } = this.props;

    const allowedExtenstions = acceptedTypes.map( type => {
      return type.split('/')[1];
    }).join(',');

    return (
      <Grid
        className={classes.select}
        alignItems="center"
        justify="center"
        direction="row"
        container={true}
        spacing={0}
        style={{ width: width || '100%', height: height || '100%' }}
      >
        <Grid>
          <Typography align={'center'} type={'body1'}>
            Drop {allowedExtenstions} files here or
          </Typography>
        </Grid>
        <Grid alignItems="center" justify="center" container={true}>
          <Button className={classes.selectFileButton}>SELECT FILE</Button>
        </Grid>
        <Grid>
          <Typography align={'center'} type={'body1'}>
            Max Filesize 5MB
          </Typography>
        </Grid>
      </Grid>
    );
  }

  private renderLoading() {
    const { mediaItem, classes, uploadFailed } = this.props;
    let buttonClass;
    if (mediaItem) {
      buttonClass = classes.successButton;
    }
    if (uploadFailed) {
      buttonClass = classes.errorButton;
    }
    return (
      <div style={{ position: 'absolute', right: 0, bottom: 0 }}>
        <div style={{ position: 'relative' }}>
          <Button variant={'fab'} color="primary" className={buttonClass}>
            {mediaItem && <CheckIcon />}
            {!mediaItem && !uploadFailed && <SaveIcon />}
            {uploadFailed && <ErrorIcon />}
          </Button>
          {!mediaItem && !uploadFailed && (
            <CircularProgress size={60} className={classes.progress} />
          )}
        </div>
      </div>
    );
  }

  public render() {
    const { classes, acceptedFiles } = this.props;
    return (
      <Grid className={classes.container}>
        {!acceptedFiles && this.renderSelect()}
        {acceptedFiles && this.renderMedia()}
      </Grid>
    );
  }
}

export default withStyles(styleSheet)(UploadArea);



// WEBPACK FOOTER //
// ./src/modules/MediaDropzone/components/UploadArea/index.tsx